import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { NotRunningPriceViewType } from 'src/domains/sportsbook/webview/components/raceSummary/utils/Utils';
import { withConfig } from 'src/withConfig';

export const RaceRunnerInfo = withConfig(theme => styled('div', { label: 'RaceRunnerInfo' })`
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    @media ${theme.star.mediaQuery.tablet} {
        flex: 1 1 auto;
    }
`);

export const RaceRunnerName = withConfig(theme => styled('span', { label: 'RaceRunnerName' })`
    color: ${theme.star.raceSummary.txtColor};
    display: block;
    font-size: ${theme.star.fontSize.small};
    line-height: 1.3334;
`);

export const RunnerDescription = withConfig(theme => styled('i', { label: 'RunnerDescription' })`
    color: ${theme.star.raceSummary.txtColorSecondary};
    display: block;
    font-size: ${theme.star.fontSize.xSmall};
    font-style: normal;
    line-height: 1.4;
`);

interface RaceRunnerNameAndPlacePropsType {
    isCast: boolean;
}

export const RaceRunnerNameAndPlace = withConfig(theme => styled('span', { label: 'RaceRunnerNameAndPlace' })<RaceRunnerNameAndPlacePropsType>`
    color: ${theme.star.raceSummary.txtColor};
    display: block;
    font-size: ${theme.star.meetingsAntePost.typography.fontSizePrimary};
    font-weight: ${theme.star.meetingsAntePost.typography.fontWeightPrimary};
    line-height: ${theme.star.meetingsAntePost.typography.lineHeightPrimary};
    ${({ isCast }): SerializedStyles | null => isCast ? css`
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        @media ${theme.star.mediaQuery.tablet} {
            max-width: none;
        }
    ` : null}
`);

export const RunnerDetails = withConfig(theme => styled('i', { label: 'RunnerDetails' })`
    color: ${theme.star.raceSummary.txtColorSecondary};
    display: block;
    font-size: ${theme.star.fontSize.xSmall};
    font-style: normal;
    line-height: 1.4;
`);

export const NonRunnerCell = withConfig(theme => styled('span', { label: 'NonRunnerCell' })<NotRunningPriceViewType>`
    align-items: center;
    border-right: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'none': `1px solid ${theme.star.raceSummary.borderColor}`};
    display: flex;
    flex: ${({ extraPlaces }): string => extraPlaces === true ? '0 0 64px' : '0 0 48px'};
    font-size: ${theme.star.fontSize.small};
    justify-content: center;
    margin-left: -1px;
    width: ${({ extraPlaces }): string => extraPlaces === true ? '64px' : '48px'};
    @media ${theme.star.mediaQuery.tablet} {
        flex: 0 0 64px;
        width: 64px;
        font-size: ${theme.star.fontSize.xRegular};
    }
`);

export const SpanSelection = withConfig(theme => styled('span', { label: 'SpanSelection' })`
    background-color: ${theme.star.raceSummary.bgColor};
    border-left: 1px solid ${theme.star.raceSummary.borderColor};
    flex-shrink: 0;
    margin-left: -1px;
    &:last-of-type {
        border-right: 0;
    }
`);
